(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["career-audit"] && !Shopify.designMode) return;
  try {
    
'use strict';
const plans = {
  audit: { title: 'Finance Resume + LinkedIn Audit', price: 87, standardVariant: '53006496891165', rushVariant: '53006496923933', copy: 'An experienced finance professional reviews your resume and LinkedIn. You receive a written audit, a prioritized revision plan, the Finance ATS guide, an application tracker, and networking scripts and tracker.' },
  complete: { title: 'Complete Finance Package', price: 297, standardVariant: '53006498005277', rushVariant: '53006498038045', copy: 'Get a professionally rewritten, 2026 ATS-tested resume, a professionally written finance cover letter, LinkedIn Makeover, positioning aligned to target roles, a one-on-one strategy call, two revisions, and final copy ready to use.' }
};
const dialog = document.querySelector('#checkout-dialog');
const expedite = document.querySelector('#expedite');
const upgradeOffer = document.querySelector('#upgrade-offer');
const upgradeButton = document.querySelector('#upgrade-complete');
let selectedPlan = 'audit';
let initialPlan = 'audit';
let checkoutOpener = null;
function updateUpgradeOffer() {
  if (initialPlan !== 'audit') {
    upgradeOffer.hidden = true;
    return;
  }
  upgradeOffer.hidden = false;
  const upgraded = selectedPlan === 'complete';
  upgradeOffer.classList.toggle('is-selected', upgraded);
  upgradeButton.setAttribute('aria-pressed', String(upgraded));
  document.querySelector('#upgrade-kicker').textContent = upgraded ? 'UPGRADE APPLIED' : 'FULL-SERVICE UPGRADE';
  upgradeButton.textContent = upgraded ? 'Keep the $87 audit' : `Upgrade for +$${plans.complete.price - plans.audit.price} ↗`;
  document.querySelector('#upgrade-status').textContent = upgraded ? 'Complete Finance Package selected.' : 'Finance Resume and LinkedIn Audit selected.';
}
function updateCheckout() {
  const plan = plans[selectedPlan];
  document.querySelector('#checkout-title').textContent = plan.title;
  document.querySelector('#checkout-copy').textContent = plan.copy;
  document.querySelector('#checkout-price').textContent = `$${plan.price}`;
  document.querySelector('#checkout-total').textContent = `$${plan.price + (expedite.checked ? 20 : 0)}`;
  updateUpgradeOffer();
}
function openCheckout(plan, opener) {
  if (!plans[plan]) return;
  checkoutOpener = opener;
  initialPlan = plan;
  selectedPlan = plan;
  expedite.checked = false;
  updateCheckout();
  dialog.showModal();
  document.body.classList.add('checkout-open');
  dialog.querySelector('.checkout-close').focus();
}
function closeCheckout() { dialog.close(); }
document.querySelectorAll('.select-plan').forEach(button => button.addEventListener('click', () => openCheckout(button.dataset.plan, button)));
dialog.querySelector('.checkout-close').addEventListener('click', closeCheckout);
dialog.addEventListener('close', () => {
  document.body.classList.remove('checkout-open');
  if (checkoutOpener) checkoutOpener.focus({ preventScroll: true });
});
dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const rect = dialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCheckout();
});
expedite.addEventListener('change', updateCheckout);
upgradeButton.addEventListener('click', () => {
  selectedPlan = selectedPlan === 'audit' ? 'complete' : 'audit';
  updateCheckout();
});
dialog.querySelector('.checkout-button').addEventListener('click', () => {
  const plan = plans[selectedPlan];
  const variantId = expedite.checked ? plan.rushVariant : plan.standardVariant;
  window.location.assign(`/cart/${variantId}:1?checkout`);
});
const examples = {
  banking: {before: 'Assisted with valuation and market research for clients.', after: 'Built comparable-company analysis across 12 public peers and summarized valuation ranges and operating metrics for senior review.'},
  fpa: {before: 'Helped analyze company financial performance.', after: 'Analyzed quarterly revenue and margin trends across four business units and summarized variance drivers for management reporting.'},
  accounting: {before: 'Supported the accounting team with monthly tasks.', after: 'Reconciled 20+ balance-sheet accounts during monthly close and investigated variances before manager review.'}
};
const exampleTabs = Array.from(document.querySelectorAll('[data-example]'));
function selectExample(tab) {
  const example = examples[tab.dataset.example];
  exampleTabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
  document.querySelector('#example-panel').setAttribute('aria-labelledby', tab.id);
  document.querySelector('#example-before').textContent = example.before;
  document.querySelector('#example-after').textContent = example.after;
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && typeof document.querySelector('#example-panel').animate === 'function') {
    document.querySelectorAll('#example-before, #example-after').forEach((paragraph, index) => {
      paragraph.getAnimations().forEach(animation => animation.cancel());
      paragraph.animate([{opacity: .25, transform: 'translateY(8px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 340, delay: index * 45, easing: 'cubic-bezier(.2,.7,.2,1)'});
    });
  }
}
exampleTabs.forEach((tab, index) => {
  tab.addEventListener('click', () => selectExample(tab));
  tab.addEventListener('keydown', event => {
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % exampleTabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + exampleTabs.length) % exampleTabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = exampleTabs.length - 1;
    else return;
    event.preventDefault();
    selectExample(exampleTabs[next]);
    exampleTabs[next].focus();
  });
});
document.querySelectorAll('.faq-list details').forEach(item => item.addEventListener('toggle', () => {
  if (item.open) document.querySelectorAll('.faq-list details').forEach(other => { if (other !== item) other.open = false; });
}));
const videoTrack = document.querySelector('#video-review-track');
const previousVideo = document.querySelector('[data-video-direction="previous"]');
const nextVideo = document.querySelector('[data-video-direction="next"]');
function updateVideoControls() {
  previousVideo.disabled = videoTrack.scrollLeft <= 2;
  nextVideo.disabled = videoTrack.scrollLeft + videoTrack.clientWidth >= videoTrack.scrollWidth - 2;
}
document.querySelectorAll('[data-video-direction]').forEach(button => button.addEventListener('click', () => {
  const card = videoTrack.querySelector('.video-card');
  const gap = parseFloat(getComputedStyle(videoTrack).columnGap) || 0;
  videoTrack.scrollBy({left: (card.getBoundingClientRect().width + gap) * (button.dataset.videoDirection === 'next' ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
}));
videoTrack.addEventListener('scroll', updateVideoControls, { passive: true });
window.addEventListener('resize', updateVideoControls);
updateVideoControls();

// Content stays visible without JavaScript; motion runs only as it enters view.
const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
if ('IntersectionObserver' in window && typeof Element.prototype.animate === 'function') {
  const revealObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      revealObserver.unobserve(entry.target);
      if (motionPreference.matches) return;
      const delay = Number(entry.target.dataset.revealDelay || 0);
      entry.target.animate([
        {opacity: .2, transform: 'translateY(22px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 620, delay, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards'});
    });
  }, {threshold: .08, rootMargin: '0px 0px -24px 0px'});
  document.querySelectorAll('.section-intro, .example-copy, .example-panel, .pricing-heading, .rush-note, .video-heading, .faq-grid > div:first-child, .closing-inner').forEach(element => revealObserver.observe(element));
  document.querySelectorAll('.difference-grid, .pricing-grid, .process-grid, .video-track, .role-strip ul').forEach(group => {
    Array.from(group.children).forEach((element, index) => {
      element.dataset.revealDelay = String(Math.min(index * 65, 195));
      revealObserver.observe(element);
    });
  });
  motionPreference.addEventListener('change', event => {
    if (event.matches) document.getAnimations().forEach(animation => animation.cancel());
  });
}


  } catch(e) { console.error(e); }
})();
})();
